import CopayCard from './CopayCard'
export default CopayCard
